<template>
  <div id="app">
    <div class="progress-bar" v-if="loading" :style="{ width: progress + '%' }"></div>
    <!-- <v-header v-if="isRouterAlive"></v-header> -->
    <PersonalNav v-if="isRouterAlive"/>
    <TypeNav :obj="TypeRoute"/>
    <transition name="page-fade" mode="out-in">
      <router-view></router-view>
    </transition>
    <VFoot :obj="FooterData"/>
  </div>
</template>

<script>
import VHeader from '@/components/base/v-header'
import VFoot from '@/components/base/v-foot'
import PersonalNav from '@/components/common/TopPersonalNav'
import TypeNav from '@/components/common/TopTypeNav'
import {
  getCanvasData
} from '@/api/indexpage.js'
export default {
  name: 'App',
  components: {VHeader, VFoot, PersonalNav, TypeNav},
  provide () {
    return {
      reload: this.reload
    }
  },
  data () {
    return {
      isRouterAlive: true,
      TypeRoute: {},
      FooterData: {},
      loading: false,
      progress: 0,
      timer: null
    }
  },
  watch: {
    $route (to, from) {
      if (to.name !== from.name) {
        this.reload()
      }
    }
  },
  created () {
    this.getCanvas()
    // 在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener('beforeunload', () => {
      localStorage.setItem('messageStore', JSON.stringify(this.$store.state))
    })
    // 在页面加载时读取localStorage里的状态信息
    localStorage.getItem('messageStore') && this.$store.replaceState(Object.assign(this.$store.state, JSON.parse(localStorage.getItem('messageStore'))))
    
    // Router logic for progress bar
    this.$router.beforeEach((to, from, next) => {
      this.startLoading()
      next()
    })
    this.$router.afterEach(() => {
      this.finishLoading()
    })
  },
  methods: {
    async getCanvas () {
      var res = await getCanvasData({ terminal: '1' })
      if (!res.json) {
        return
      }
      var canvasData = JSON.parse(res.json)
      canvasData = canvasData.map(item => {
        if (item.type === 'NavType') {
          return item
        }
        if (item.type === 'Footer') {
          return item
        }
      }).filter(r => r)
      this.TypeRoute = this.giveTypeRes('NavType', canvasData)
      this.FooterData = this.giveTypeRes('Footer', canvasData)
    },
    giveTypeRes (type, data) {
      var result
      for (var key in data) {
        if (data[key].type === type) {
          result = data[key]
        }
      }
      return result
    },
    reload () {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
    startLoading () {
      this.loading = true
      this.progress = 0
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        if (this.progress < 90) {
          this.progress += Math.random() * 10
        }
      }, 150)
    },
    finishLoading () {
      this.progress = 100
      clearInterval(this.timer)
      setTimeout(() => {
        this.loading = false
      }, 300)
    }
  }
}
</script>
<style lang="scss">
#app{
  min-width: 1440px;
  background-color: #F8F9FA;
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

// Page Transitions
.page-fade-enter-active,
.page-fade-leave-active {
  transition: all 0.5s cubic-bezier(0.23, 1, 0.32, 1);
}

.page-fade-enter {
  opacity: 0;
  filter: blur(10px);
  transform: scale(0.98);
}

.page-fade-leave-to {
  opacity: 0;
  filter: blur(5px);
  transform: scale(1.02);
}

.progress-bar {
  position: fixed;
  top: 0;
  left: 0;
  height: 3px;
  background: linear-gradient(to right, #e1251b, #f3564d);
  z-index: 9999;
  transition: width 0.3s ease;
  box-shadow: 0 0 10px rgba(225, 37, 27, 0.5);
}

.el-loading-mask{
  backdrop-filter: blur(12px);
  background: rgba(255, 255, 255, 0.4) !important;
  transition: $transition-base;
  .el-loading-spinner{
    background: white;
    padding: 30px;
    border-radius: 20px;
    width: auto;
    left: 50%;
    transform: translateX(-50%);
    box-shadow: $shadow-lg;
    
    .path{
      stroke: #e1251b;
      stroke-width: 4;
    }
    .el-loading-text {
      color: #111827;
      font-weight: 700;
      font-size: 14px;
      letter-spacing: 2px;
      margin-top: 20px;
      text-transform: uppercase;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue